import {
    Create,
    TextInput,
    required,
    SimpleForm,
    DateTimeInput,
    SelectInput,
    minValue,
    NumberInput,
} from 'react-admin';
import { STATUSES } from '../../common/constants';

import FileUpload from '../../common/inputs/FileUpload';
import { Divider } from '@mui/material';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import SlugInput from '../../common/inputs/SlugInput';
import { BatchesTemplateAutoComplete } from '../../common/inputs/autoCompleteInputs/BatchTemplateAutoComplete';
import { validateEndDateAfterStart } from '../../common/string-utilities';

const BatchesCreate = () => {
    return (
        <Create redirect={'/batches'}>
            <SimpleForm mode="onChange">
                <FileUpload type="VIDEO_THUMBNAIL" source="image" accept={'image/*'} />
                <TextInput source="title" validate={[required()]} fullWidth />
                <SlugInput source="slug" fullWidth />
                <NumberInput
                    source="displayOrder"
                    type={'number'}
                    validate={[required(), minValue(0)]}
                    fullWidth
                />
                <BatchesTemplateAutoComplete source="templateId" />
                <DateTimeInput source="startTime" validate={[required()]} fullWidth />
                <DateTimeInput
                    source="endTime"
                    validate={[
                        required(),
                        validateEndDateAfterStart(
                            'startTime',
                            'End time cannot be earlier than start time',
                        ),
                    ]}
                    fullWidth
                />
                <DateTimeInput source="registrationStartDate" validate={[required()]} fullWidth />
                <DateTimeInput
                    source="registrationEndDate"
                    validate={[
                        required(),
                        validateEndDateAfterStart(
                            'registrationStartDate',
                            'Registration end date cannot be earlier than registration start date',
                        ),
                    ]}
                    fullWidth
                />
                <SelectInput
                    source="status"
                    label={'Status'}
                    fullWidth
                    validate={[required()]}
                    choices={STATUSES}
                />

                <TextInput
                    rows={4}
                    multiline
                    source={'textDescription'}
                    fullWidth
                    validate={[required()]}
                />
                <HTMLEditorInput
                    source={'htmlDescription'}
                    fullWidth
                    validate={[required(), validHtml]}
                />
                <Divider />
            </SimpleForm>
        </Create>
    );
};

export default BatchesCreate;
